import { Logger } from "tslog";
// Create a single logger instance
const logger = new Logger({
    name: "Excel-Core",
    type: "pretty",
    prettyLogTemplate: "{{yyyy}}-{{mm}}-{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}} {{logLevelName}} [{{name}}] ",
    prettyLogTimeZone: "local",
    minLevel: process.env.NODE_ENV === "development" ? 3 : 2,
});
// Export convenience methods
export const log = {
    error: (...args) => logger.error(...args),
    warn: (...args) => logger.warn(...args),
    info: (...args) => logger.info(...args),
    debug: (...args) => logger.debug(...args),
    trace: (...args) => logger.trace(...args),
};
//# sourceMappingURL=logger.js.map